import { register, CloudObject, defineProperty, defineRelation, Direction, File as OFile } from 'olympe';
import Picture from "./Picture";
import Evaluation from "./Evaluation";
import InspectionEntity from "./InspectionEntity";

/**
 * @extends {CloudObject}
 */
export default class Observation extends CloudObject {
    /**
     * @return {string}
     */
    getComment() {
        return this.get(Observation.commentProp);
    }
}

// Hardcoded tags
register('01880fb091599f8d99b7', Observation);
Observation.commentProp = defineProperty('01880fb0c3dc359f04e8');
Observation.targetRel = defineRelation('01880fc0f576af2ee0ed', Observation, InspectionEntity);
Observation.picturesRel = defineRelation('01880fc11345c99937b6', Observation, Picture);
Observation.chartImageResultsRel = defineRelation('01880fc160e4f86e6b17', Observation, OFile);
Observation.charImageOverallRel = defineRelation('01880fc1789ebebc8160', Observation, OFile);
Observation.chartImageAspectsRel = defineRelation('01880fc19518a510ee69', Observation, OFile);
Observation.evalutationRel = defineRelation('01896d29133e0bcc3498', Observation, Evaluation);
Observation.additionalEvalsRel = defineRelation('0189785c6aceee8d89fe', Observation, Evaluation);
Observation.inverse_reportobservationsRel = defineRelation('01880fb8e0feda88393e', Direction.ORIGIN);
Observation.inverse_unitobservationsRel = defineRelation('0188d02d79fba3bf02ce', Direction.ORIGIN);
Observation.inverse_systemobservationRel = defineRelation('0188fc071c22f0d611bd', Direction.ORIGIN);
